import { looksLikeWorkspaceUrl, validateWorkspaceUrl } from "./workspaceUrl";

export const INVALID_LOGIN_EMAIL_MESSAGE =
  "Please enter a valid email address.";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function emailDomainHasTld(email) {
  const domain = String(email || "").split("@")[1] || "";
  const parts = domain.split(".").filter(Boolean);
  if (parts.length < 2) return false;
  return /^[a-z]{2,63}$/i.test(parts[parts.length - 1]);
}

export function validateLoginIdentifier(input) {
  const v = String(input || "").trim();
  if (!v) {
    return { ok: false, message: "Please enter your work email" };
  }

  if (v.includes("@")) {
    if (!emailDomainHasTld(v) || !EMAIL_RE.test(v)) {
      return {
        ok: false,
        message: INVALID_LOGIN_EMAIL_MESSAGE,
      };
    }
    return { ok: true, kind: "email", value: v.toLowerCase() };
  }

  if (looksLikeWorkspaceUrl(v)) {
    const ws = validateWorkspaceUrl(v);
    if (!ws.ok) return ws;
    return {
      ok: false,
      message: `Open ${ws.value} in your browser, then sign in with your work email.`,
    };
  }

  return {
    ok: false,
    message: "Enter your work email address (e.g. you@company.com)",
  };
}
